export const allCountriesList = [
    {
        "code": "AF",
        "country_flag": "afghanistan.png",
        "country_phone_code": "93",
        "currency": "USD",
        "elevated_risk": 1,
        "id": "581c6e2536c2d3cf0080188b",
        "is_bfm": false,
        "is_host": 0,
        "lang": "AF",
        "name": "Afghanistan",
        "non_standart_pickup": 1,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+4:30",
        "weight_unit": "kg"
    },
    {
        "code": "AL",
        "country_flag": "albania.png",
        "country_phone_code": "355",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e1b36c2d3cf00801868",
        "is_bfm": false,
        "is_host": 0,
        "lang": "AL",
        "name": "Albania",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "DZ",
        "country_flag": "algeria.png",
        "country_phone_code": "213",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e3c36c2d3cf008018c5",
        "is_bfm": false,
        "is_host": 0,
        "lang": "DZ",
        "name": "Algeria",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "AS",
        "country_flag": "american-samoa.png",
        "country_phone_code": "1-684",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e6936c2d3cf00801904",
        "is_bfm": false,
        "is_host": 0,
        "lang": "AS",
        "name": "American Samoa",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-11",
        "weight_unit": "kg"
    },
    {
        "code": "AD",
        "country_flag": "andorra.png",
        "country_phone_code": "376",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e4136c2d3cf008018d2",
        "is_bfm": false,
        "is_host": 0,
        "lang": "AD",
        "name": "Andorra",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "AO",
        "country_flag": "angola.png",
        "country_phone_code": "244",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e0e36c2d3cf0080184e",
        "is_bfm": false,
        "is_host": 0,
        "lang": "AO",
        "name": "Angola",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "AI",
        "country_flag": "anguilla.png",
        "country_phone_code": "1",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "59afd22d893351d992c0861f",
        "is_bfm": false,
        "is_host": 0,
        "lang": "AI",
        "name": "Anguilla",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-4",
        "weight_unit": "lbs"
    },
    {
        "code": "AG",
        "country_flag": "antigua-and-barbuda.png",
        "country_phone_code": "1-268",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e5836c2d3cf008018ef",
        "is_bfm": false,
        "is_host": 0,
        "lang": "AG",
        "name": "Antigua and Barbuda",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-4",
        "weight_unit": "kg"
    },
    {
        "code": "AR",
        "country_flag": "argentina.png",
        "country_phone_code": "54",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e4c36c2d3cf008018e1",
        "is_bfm": false,
        "is_host": 0,
        "lang": "AR",
        "name": "Argentina",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-3",
        "weight_unit": "kg"
    },
    {
        "code": "AM",
        "country_flag": "armenia.png",
        "country_phone_code": "374",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e1136c2d3cf00801853",
        "is_bfm": false,
        "is_host": 0,
        "lang": "AM",
        "name": "Armenia",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+4",
        "weight_unit": "kg"
    },
    {
        "code": "AW",
        "country_flag": "aruba.png",
        "country_phone_code": 297,
        "currency": "USD",
        "elevated_risk": 0,
        "id": "5e1d719851d75f1c3f69ffa6",
        "is_bfm": false,
        "is_host": 0,
        "lang": "AW",
        "name": "Aruba",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-4",
        "weight_unit": "kg"
    },
    {
        "code": "AU",
        "country_flag": "australia.png",
        "country_phone_code": "61",
        "currency": "AUD",
        "elevated_risk": 0,
        "id": "581afd4336c2d3cf00801552",
        "is_bfm": true,
        "is_host": 1,
        "lang": "au-AU",
        "name": "Australia",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+8",
        "weight_unit": "kg"
    },
    {
        "code": "AT",
        "country_flag": "austria.png",
        "country_phone_code": "43",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e3d36c2d3cf008018c8",
        "is_bfm": false,
        "is_host": 0,
        "lang": "AT",
        "name": "Austria",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "AZ",
        "country_flag": "azerbaijan.png",
        "country_phone_code": "994",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e0f36c2d3cf0080184f",
        "is_bfm": false,
        "is_host": 1,
        "lang": "AZ",
        "name": "Azerbaijan",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+4",
        "weight_unit": "kg"
    },
    {
        "code": "BS",
        "country_flag": "bahamas.png",
        "country_phone_code": "1",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e5336c2d3cf008018ea",
        "is_bfm": false,
        "is_host": 0,
        "lang": "BS",
        "name": "Bahamas",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-5",
        "weight_unit": "kg"
    },
    {
        "code": "BH",
        "country_flag": "bahrain.png",
        "country_phone_code": "973",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e1836c2d3cf00801863",
        "is_bfm": false,
        "is_host": 0,
        "lang": "BH",
        "name": "Bahrain",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+3",
        "weight_unit": "kg"
    },
    {
        "code": "BD",
        "country_flag": "bangladesh.png",
        "country_phone_code": "880",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2636c2d3cf0080188d",
        "is_bfm": false,
        "is_host": 0,
        "lang": "BD",
        "name": "Bangladesh",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+6",
        "weight_unit": "kg"
    },
    {
        "code": "BB",
        "country_flag": "barbados.png",
        "country_phone_code": "1-246",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e4836c2d3cf008018da",
        "is_bfm": false,
        "is_host": 0,
        "lang": "BB",
        "name": "Barbados",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-4",
        "weight_unit": "kg"
    },
    {
        "code": "BE",
        "country_flag": "belgium.png",
        "country_phone_code": "32",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e3f36c2d3cf008018cf",
        "is_bfm": false,
        "is_host": 0,
        "lang": "BE",
        "name": "Belgium",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "BZ",
        "country_flag": "belize.png",
        "country_phone_code": "501",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e5a36c2d3cf008018f3",
        "is_bfm": false,
        "is_host": 0,
        "lang": "BZ",
        "name": "Belize",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-6",
        "weight_unit": "kg"
    },
    {
        "code": "BJ",
        "country_flag": "benin.png",
        "country_phone_code": "229",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e3936c2d3cf008018bc",
        "is_bfm": false,
        "is_host": 0,
        "lang": "BJ",
        "name": "Benin",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "BM",
        "country_flag": "bermuda.png",
        "country_phone_code": "1-441",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e5436c2d3cf008018eb",
        "is_bfm": false,
        "is_host": 0,
        "lang": "BM",
        "name": "Bermuda",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-4",
        "weight_unit": "kg"
    },
    {
        "code": "BT",
        "country_flag": "bhutan.png",
        "country_phone_code": "975",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2736c2d3cf00801892",
        "is_bfm": false,
        "is_host": 0,
        "lang": "BT",
        "name": "Bhutan",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+6",
        "weight_unit": "kg"
    },
    {
        "code": "BO",
        "country_flag": "bolivia.png",
        "country_phone_code": "591",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e6636c2d3cf008018ff",
        "is_bfm": false,
        "is_host": 0,
        "lang": "BO",
        "name": "Bolivia",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-4",
        "weight_unit": "kg"
    },
    {
        "code": "BQ",
        "country_flag": "bonaire,-sint-eustatius,-and-saba.png",
        "country_phone_code": 599,
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e5336c2d3cf008018e8",
        "is_bfm": false,
        "is_host": 0,
        "lang": "BQ",
        "name": "Bonaire, Sint Eustatius, and Saba",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-4",
        "weight_unit": "kg"
    },
    {
        "code": "BA",
        "country_flag": "bosnia-and-herzegovina.png",
        "country_phone_code": "387",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e4636c2d3cf008018d8",
        "is_bfm": false,
        "is_host": 0,
        "lang": "BA",
        "name": "Bosnia and Herzegovina",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "BW",
        "country_flag": "botswana.png",
        "country_phone_code": "267",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2336c2d3cf00801884",
        "is_bfm": false,
        "is_host": 0,
        "lang": "BW",
        "name": "Botswana",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+2",
        "weight_unit": "kg"
    },
    {
        "code": "BR",
        "country_flag": "brazil.png",
        "country_phone_code": "55",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e4b36c2d3cf008018de",
        "is_bfm": false,
        "is_host": 0,
        "lang": "BR",
        "name": "Brazil",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-2",
        "weight_unit": "kg"
    },
    {
        "code": "BN",
        "country_flag": "brunei.png",
        "country_phone_code": "673",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2c36c2d3cf008018a0",
        "is_bfm": false,
        "is_host": 0,
        "lang": "BN",
        "name": "Brunei",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+8",
        "weight_unit": "kg"
    },
    {
        "code": "BG",
        "country_flag": "bulgaria.png",
        "country_phone_code": "359",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e1c36c2d3cf0080186d",
        "is_bfm": false,
        "is_host": 0,
        "lang": "BG",
        "name": "Bulgaria",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+2",
        "weight_unit": "kg"
    },
    {
        "code": "BF",
        "country_flag": "burkina-faso.png",
        "country_phone_code": "226",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e3736c2d3cf008018b8",
        "is_bfm": false,
        "is_host": 0,
        "lang": "BF",
        "name": "Burkina Faso",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+0",
        "weight_unit": "kg"
    },
    {
        "code": "BI",
        "country_flag": "burundi.png",
        "country_phone_code": "257",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e1c36c2d3cf0080186b",
        "is_bfm": false,
        "is_host": 0,
        "lang": "BI",
        "name": "Burundi",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+3",
        "weight_unit": "kg"
    },
    {
        "code": "KH",
        "country_flag": "cambodia.png",
        "country_phone_code": "855",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2c36c2d3cf008018a1",
        "is_bfm": false,
        "is_host": 0,
        "lang": "KH",
        "name": "Cambodia",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+7",
        "weight_unit": "kg"
    },
    {
        "code": "CM",
        "country_flag": "cameroon.png",
        "country_phone_code": "237",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e3236c2d3cf008018af",
        "is_bfm": false,
        "is_host": 0,
        "lang": "CM",
        "name": "Cameroon",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "CA",
        "country_flag": "canada.png",
        "country_phone_code": "1",
        "currency": "CAD",
        "elevated_risk": 0,
        "id": "581afd7436c2d3cf00801553",
        "is_bfm": true,
        "is_host": 1,
        "lang": "ca-CA",
        "name": "Canada",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-5",
        "weight_unit": "kg"
    },
    {
        "code": "IC",
        "country_flag": "canary-islands.png",
        "country_phone_code": 0,
        "currency": "USD",
        "elevated_risk": 0,
        "id": "5e1d719851d75f1c3f69ffab",
        "is_bfm": false,
        "is_host": 0,
        "lang": "IC",
        "name": "Canary Islands",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT",
        "weight_unit": "kg"
    },
    {
        "code": "CV",
        "country_flag": "cape-verde.png",
        "country_phone_code": "238",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e4936c2d3cf008018db",
        "is_bfm": false,
        "is_host": 0,
        "lang": "CV",
        "name": "Cape Verde",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-1",
        "weight_unit": "kg"
    },
    {
        "code": "KY",
        "country_flag": "cayman-islands.png",
        "country_phone_code": 1345,
        "currency": "USD",
        "elevated_risk": 0,
        "id": "5e1d719851d75f1c3f69ffac",
        "is_bfm": false,
        "is_host": 0,
        "lang": "KY",
        "name": "Cayman Islands",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-5",
        "weight_unit": "kg"
    },
    {
        "code": "CF",
        "country_flag": "central-african-republic.png",
        "country_phone_code": "236",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e1436c2d3cf00801859",
        "is_bfm": false,
        "is_host": 0,
        "lang": "CF",
        "name": "Central African Republic",
        "non_standart_pickup": 0,
        "restricted_destination": 1,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "TD",
        "country_flag": "chad.png",
        "country_phone_code": "235",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e1436c2d3cf0080185b",
        "is_bfm": false,
        "is_host": 0,
        "lang": "TD",
        "name": "Chad",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "CL",
        "country_flag": "chile.png",
        "country_phone_code": "56",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e6536c2d3cf008018fe",
        "is_bfm": false,
        "is_host": 0,
        "lang": "CL",
        "name": "Chile",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-4",
        "weight_unit": "kg"
    },
    {
        "code": "CN",
        "country_flag": "china.png",
        "country_phone_code": "86",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2836c2d3cf00801894",
        "is_bfm": false,
        "is_host": 0,
        "lang": "CN",
        "name": "China",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+8",
        "weight_unit": "kg"
    },
    {
        "code": "CO",
        "country_flag": "colombia.png",
        "country_phone_code": "57",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e6236c2d3cf008018fa",
        "is_bfm": false,
        "is_host": 0,
        "lang": "CO",
        "name": "Colombia",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-5",
        "weight_unit": "kg"
    },
    {
        "code": "KM",
        "country_flag": "comoros.png",
        "country_phone_code": "269",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2336c2d3cf00801881",
        "is_bfm": false,
        "is_host": 0,
        "lang": "KM",
        "name": "Comoros",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+3",
        "weight_unit": "kg"
    },
    {
        "code": "CD",
        "country_flag": "congo.png",
        "country_phone_code": "243",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e1236c2d3cf00801857",
        "is_bfm": false,
        "is_host": 0,
        "lang": "CD",
        "name": "Congo",
        "non_standart_pickup": 1,
        "restricted_destination": 1,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "CK",
        "country_flag": "cook-islands.png",
        "country_phone_code": 682,
        "currency": "USD",
        "elevated_risk": 0,
        "id": "5e1d719851d75f1c3f69ffa7",
        "is_bfm": false,
        "is_host": 0,
        "lang": "CK",
        "name": "Cook Islands",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-10",
        "weight_unit": "kg"
    },
    {
        "code": "CR",
        "country_flag": "costa-rica.png",
        "country_phone_code": "506",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e6036c2d3cf008018f8",
        "is_bfm": false,
        "is_host": 0,
        "lang": "CR",
        "name": "Costa Rica",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-6",
        "weight_unit": "kg"
    },
    {
        "code": "HR",
        "country_flag": "croatia.png",
        "country_phone_code": "385",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e4436c2d3cf008018d7",
        "is_bfm": false,
        "is_host": 0,
        "lang": "HR",
        "name": "Croatia",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "CU",
        "country_flag": "cuba.png",
        "country_phone_code": "53",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e5336c2d3cf008018e9",
        "is_bfm": false,
        "is_host": 0,
        "lang": "CU",
        "name": "Cuba",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-5",
        "weight_unit": "kg"
    },
    {
        "code": "CW",
        "country_flag": "curacao.png",
        "country_phone_code": 599,
        "currency": "USD",
        "elevated_risk": 0,
        "id": "5e1d9e7d51d75f203aa34dad",
        "is_bfm": false,
        "is_host": 0,
        "lang": "CW",
        "name": "Curacao",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-4",
        "weight_unit": "kg"
    },
    {
        "code": "CY",
        "country_flag": "cyprus.png",
        "country_phone_code": "357",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e0a36c2d3cf00801847",
        "is_bfm": false,
        "is_host": 0,
        "lang": "CY",
        "name": "Cyprus",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+2",
        "weight_unit": "kg"
    },
    {
        "code": "CZ",
        "country_flag": "czech-republic.png",
        "country_phone_code": "420",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e4136c2d3cf008018d4",
        "is_bfm": false,
        "is_host": 0,
        "lang": "CZ",
        "name": "Czech Republic",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "DK",
        "country_flag": "denmark.png",
        "country_phone_code": "45",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e3d36c2d3cf008018c9",
        "is_bfm": false,
        "is_host": 1,
        "lang": "DK",
        "name": "Denmark",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "DJ",
        "country_flag": "djibouti.png",
        "country_phone_code": 253,
        "currency": "USD",
        "elevated_risk": 0,
        "id": "5e1d719851d75f1c3f69ffa8",
        "is_bfm": false,
        "is_host": 0,
        "lang": "DJ",
        "name": "Djibouti",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+3",
        "weight_unit": "kg"
    },
    {
        "code": "DM",
        "country_flag": "dominica.png",
        "country_phone_code": "1-767",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e5736c2d3cf008018ee",
        "is_bfm": false,
        "is_host": 0,
        "lang": "DM",
        "name": "Dominica",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-4",
        "weight_unit": "kg"
    },
    {
        "code": "DO",
        "country_flag": "dominican-republic.png",
        "country_phone_code": "1",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e5236c2d3cf008018e7",
        "is_bfm": false,
        "is_host": 0,
        "lang": "DO",
        "name": "Dominican Republic",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-4",
        "weight_unit": "kg"
    },
    {
        "code": "TL",
        "country_flag": "east-timor.png",
        "country_phone_code": 670,
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2a36c2d3cf0080189b",
        "is_bfm": false,
        "is_host": 0,
        "lang": "TL",
        "name": "East Timor",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+9",
        "weight_unit": "kg"
    },
    {
        "code": "EC",
        "country_flag": "ecuador.png",
        "country_phone_code": "593 ",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e6136c2d3cf008018f9",
        "is_bfm": false,
        "is_host": 0,
        "lang": "EC",
        "name": "Ecuador",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-5",
        "weight_unit": "kg"
    },
    {
        "code": "EG",
        "country_flag": "egypt.png",
        "country_phone_code": "20",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e1936c2d3cf00801867",
        "is_bfm": false,
        "is_host": 0,
        "lang": "EG",
        "name": "Egypt",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+2",
        "weight_unit": "kg"
    },
    {
        "code": "SV",
        "country_flag": "el-salvador.png",
        "country_phone_code": "503",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e5b36c2d3cf008018f4",
        "is_bfm": false,
        "is_host": 0,
        "lang": "SV",
        "name": "El Salvador",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-6",
        "weight_unit": "kg"
    },
    {
        "code": "GQ",
        "country_flag": "equatorial-guinea.png",
        "country_phone_code": "240",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e3736c2d3cf008018b6",
        "is_bfm": false,
        "is_host": 0,
        "lang": "GQ",
        "name": "Equatorial Guinea",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "ER",
        "country_flag": "eritrea.png",
        "country_phone_code": "291",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e1936c2d3cf00801866",
        "is_bfm": false,
        "is_host": 0,
        "lang": "ER",
        "name": "Eritrea",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+3",
        "weight_unit": "kg"
    },
    {
        "code": "EE",
        "country_flag": "estonia.png",
        "country_phone_code": "372",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e1d36c2d3cf0080186f",
        "is_bfm": false,
        "is_host": 0,
        "lang": "EE",
        "name": "Estonia",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+2",
        "weight_unit": "kg"
    },
    {
        "code": "FK",
        "country_flag": "falkland-island.png",
        "country_phone_code": 500,
        "currency": "USD",
        "elevated_risk": 0,
        "id": "5e1d719851d75f1c3f69ffa9",
        "is_bfm": false,
        "is_host": 0,
        "lang": "FK",
        "name": "Falkland Island",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-3",
        "weight_unit": "kg"
    },
    {
        "code": "FO",
        "country_flag": "faroe-islands.png",
        "country_phone_code": "298",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "58510d643901ad0e8d29edf0",
        "is_bfm": false,
        "is_host": 0,
        "lang": "FO",
        "name": "Faroe Islands",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+0",
        "weight_unit": "kg"
    },
    {
        "code": "FM",
        "country_flag": "federated-states-of-micronesia.png",
        "country_phone_code": "691",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2d36c2d3cf008018a5",
        "is_bfm": false,
        "is_host": 0,
        "lang": "FM",
        "name": "Federated States of Micronesia",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+11",
        "weight_unit": "kg"
    },
    {
        "code": "FJ",
        "country_flag": "fiji.png",
        "country_phone_code": "679",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e3236c2d3cf008018ae",
        "is_bfm": false,
        "is_host": 0,
        "lang": "FJ",
        "name": "Fiji",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+12",
        "weight_unit": "kg"
    },
    {
        "code": "FI",
        "country_flag": "finland.png",
        "country_phone_code": "358",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2036c2d3cf00801877",
        "is_bfm": false,
        "is_host": 0,
        "lang": "FI",
        "name": "Finland",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+2",
        "weight_unit": "kg"
    },
    {
        "code": "FR",
        "country_flag": "france.png",
        "country_phone_code": "33",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e4036c2d3cf008018d1",
        "is_bfm": true,
        "is_host": 1,
        "lang": "FR",
        "name": "France",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "GF",
        "country_flag": "french-guyana.png",
        "country_phone_code": 594,
        "currency": "USD",
        "elevated_risk": 0,
        "id": "5e1d719851d75f1c3f69ffaa",
        "is_bfm": false,
        "is_host": 0,
        "lang": "GF",
        "name": "French Guyana",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-3",
        "weight_unit": "kg"
    },
    {
        "code": "PF",
        "country_flag": "french-polynesia.png",
        "country_phone_code": "689",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e6736c2d3cf00801901",
        "is_bfm": false,
        "is_host": 0,
        "lang": "PF",
        "name": "French Polynesia",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+0",
        "weight_unit": "kg"
    },
    {
        "code": "GA",
        "country_flag": "gabon.png",
        "country_phone_code": "241",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e3936c2d3cf008018bd",
        "is_bfm": false,
        "is_host": 0,
        "lang": "GA",
        "name": "Gabon",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "GM",
        "country_flag": "gambia.png",
        "country_phone_code": "220",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e3a36c2d3cf008018c0",
        "is_bfm": false,
        "is_host": 0,
        "lang": "GM",
        "name": "Gambia",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+0",
        "weight_unit": "kg"
    },
    {
        "code": "GE",
        "country_flag": "georgia.png",
        "country_phone_code": "995",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e1e36c2d3cf00801873",
        "is_bfm": false,
        "is_host": 0,
        "lang": "GE",
        "name": "Georgia",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+4",
        "weight_unit": "kg"
    },
    {
        "code": "DE",
        "country_flag": "germany.png",
        "country_phone_code": "49",
        "currency": "EUR",
        "elevated_risk": 0,
        "id": "581afd8336c2d3cf00801554",
        "is_bfm": true,
        "is_host": 1,
        "lang": "de-DE",
        "name": "Germany",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "lbs"
    },
    {
        "code": "GH",
        "country_flag": "ghana.png",
        "country_phone_code": "233",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e3636c2d3cf008018b5",
        "is_bfm": false,
        "is_host": 0,
        "lang": "GH",
        "name": "Ghana",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+0",
        "weight_unit": "kg"
    },
    {
        "code": "GI",
        "country_flag": "gibraltar.png",
        "country_phone_code": 350,
        "currency": "USD",
        "elevated_risk": 0,
        "id": "5e1d719851d75f1c3f69ffaf",
        "is_bfm": false,
        "is_host": 0,
        "lang": "GI",
        "name": "Gibraltar",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "GR",
        "country_flag": "greece.png",
        "country_phone_code": "30",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e1636c2d3cf0080185d",
        "is_bfm": false,
        "is_host": 1,
        "lang": "GR",
        "name": "Greece",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+2",
        "weight_unit": "kg"
    },
    {
        "code": "GL",
        "country_flag": "greenland.png",
        "country_phone_code": "299",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e4b36c2d3cf008018df",
        "is_bfm": false,
        "is_host": 0,
        "lang": "GL",
        "name": "Greenland",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+0",
        "weight_unit": "kg"
    },
    {
        "code": "GD",
        "country_flag": "grenada.png",
        "country_phone_code": "1-473",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e5a36c2d3cf008018f2",
        "is_bfm": false,
        "is_host": 0,
        "lang": "GD",
        "name": "Grenada",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-4",
        "weight_unit": "kg"
    },
    {
        "code": "GP",
        "country_flag": "guadeloupe.png",
        "country_phone_code": 590,
        "currency": "USD",
        "elevated_risk": 0,
        "id": "5e1d719851d75f1c3f69ffb0",
        "is_bfm": false,
        "is_host": 0,
        "lang": "GP",
        "name": "Guadeloupe",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "",
        "weight_unit": "kg"
    },
    {
        "code": "GU",
        "country_flag": "guam.png",
        "country_phone_code": "1",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "594147fc119a87a31efd13ce",
        "is_bfm": false,
        "is_host": 0,
        "lang": "GU",
        "name": "Guam",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "",
        "weight_unit": "kg"
    },
    {
        "code": "GT",
        "country_flag": "guatemala.png",
        "country_phone_code": "502",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e5c36c2d3cf008018f5",
        "is_bfm": false,
        "is_host": 0,
        "lang": "GT",
        "name": "Guatemala",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-6",
        "weight_unit": "kg"
    },
    {
        "code": "GG",
        "country_flag": "guernsey.png",
        "country_phone_code": 44,
        "currency": "USD",
        "elevated_risk": 0,
        "id": "5e1d719851d75f1c3f69ffb1",
        "is_bfm": false,
        "is_host": 0,
        "lang": "GG",
        "name": "Guernsey",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+0",
        "weight_unit": "kg"
    },
    {
        "code": "GN",
        "country_flag": "guinea.png",
        "country_phone_code": "224",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e3a36c2d3cf008018c1",
        "is_bfm": false,
        "is_host": 0,
        "lang": "GN",
        "name": "Guinea",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+0",
        "weight_unit": "kg"
    },
    {
        "code": "GW",
        "country_flag": "guinea-bissau.png",
        "country_phone_code": "245",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e3836c2d3cf008018ba",
        "is_bfm": false,
        "is_host": 0,
        "lang": "GW",
        "name": "Guinea-Bissau",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+0",
        "weight_unit": "kg"
    },
    {
        "code": "GY",
        "country_flag": "guyana.png",
        "country_phone_code": "592",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e4a36c2d3cf008018dc",
        "is_bfm": false,
        "is_host": 0,
        "lang": "GY",
        "name": "Guyana",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-3",
        "weight_unit": "kg"
    },
    {
        "code": "HT",
        "country_flag": "haiti.png",
        "country_phone_code": "509",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e6336c2d3cf008018fd",
        "is_bfm": false,
        "is_host": 0,
        "lang": "HT",
        "name": "Haiti",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-5",
        "weight_unit": "kg"
    },
    {
        "code": "HN",
        "country_flag": "honduras.png",
        "country_phone_code": "504",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e5d36c2d3cf008018f6",
        "is_bfm": false,
        "is_host": 0,
        "lang": "HN",
        "name": "Honduras",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-6",
        "weight_unit": "kg"
    },
    {
        "code": "HK",
        "country_flag": "hong-kong.png",
        "country_phone_code": "852",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2b36c2d3cf0080189f",
        "is_bfm": true,
        "is_host": 1,
        "lang": "HK",
        "name": "Hong Kong",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+8",
        "weight_unit": "kg"
    },
    {
        "code": "HU",
        "country_flag": "hungary.png",
        "country_phone_code": "36",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2036c2d3cf00801879",
        "is_bfm": false,
        "is_host": 0,
        "lang": "HU",
        "name": "Hungary",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "IS",
        "country_flag": "iceland.png",
        "country_phone_code": "354",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e3e36c2d3cf008018ca",
        "is_bfm": false,
        "is_host": 0,
        "lang": "IS",
        "name": "Iceland",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+0",
        "weight_unit": "kg"
    },
    {
        "code": "IN",
        "country_flag": "india.png",
        "country_phone_code": "91",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2836c2d3cf00801893",
        "is_bfm": false,
        "is_host": 0,
        "lang": "IN",
        "name": "India",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+5:30",
        "weight_unit": "kg"
    },
    {
        "code": "ID",
        "country_flag": "indonesia.png",
        "country_phone_code": "62",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2736c2d3cf0080188e",
        "is_bfm": false,
        "is_host": 0,
        "lang": "ID",
        "name": "Indonesia",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+7",
        "weight_unit": "kg"
    },
    {
        "code": "IR",
        "country_flag": "iran.png",
        "country_phone_code": "98",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e0e36c2d3cf0080184d",
        "is_bfm": false,
        "is_host": 0,
        "lang": "IR",
        "name": "Iran",
        "non_standart_pickup": 1,
        "restricted_destination": 1,
        "status": 1,
        "timezone": "GMT+3:30",
        "weight_unit": "kg"
    },
    {
        "code": "IQ",
        "country_flag": "iraq.png",
        "country_phone_code": "964",
        "currency": "USD",
        "elevated_risk": 1,
        "id": "581c6e0d36c2d3cf0080184b",
        "is_bfm": false,
        "is_host": 0,
        "lang": "IQ",
        "name": "Iraq",
        "non_standart_pickup": 1,
        "restricted_destination": 1,
        "status": 1,
        "timezone": "GMT+3",
        "weight_unit": "kg"
    },
    {
        "code": "IE",
        "country_flag": "ireland.png",
        "country_phone_code": "353",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e3e36c2d3cf008018cb",
        "is_bfm": false,
        "is_host": 0,
        "lang": "IE",
        "name": "Ireland",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+0",
        "weight_unit": "kg"
    },
    {
        "code": "IL",
        "country_flag": "israel.png",
        "country_phone_code": "972",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e1736c2d3cf0080185f",
        "is_bfm": false,
        "is_host": 0,
        "lang": "IL",
        "name": "Israel",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+2",
        "weight_unit": "kg"
    },
    {
        "code": "IT",
        "country_flag": "italy.png",
        "country_phone_code": "39",
        "currency": "EUR",
        "elevated_risk": 0,
        "id": "581afd9336c2d3cf00801555",
        "is_bfm": false,
        "is_host": 1,
        "lang": "it-IT",
        "name": "Italy",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "CI",
        "country_flag": "ivory-coast.png",
        "country_phone_code": "225",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e3636c2d3cf008018b4",
        "is_bfm": false,
        "is_host": 0,
        "lang": "CI",
        "name": "Ivory Coast",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "",
        "weight_unit": "kg"
    },
    {
        "code": "JM",
        "country_flag": "jamaica.png",
        "country_phone_code": "1-876",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e5136c2d3cf008018e6",
        "is_bfm": false,
        "is_host": 0,
        "lang": "JM",
        "name": "Jamaica",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-5",
        "weight_unit": "kg"
    },
    {
        "code": "JP",
        "country_flag": "japan.png",
        "country_phone_code": "81",
        "currency": "JPY",
        "elevated_risk": 0,
        "id": "581afdb336c2d3cf00801556",
        "is_bfm": true,
        "is_host": 1,
        "lang": "jp-JP",
        "name": "Japan",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+9",
        "weight_unit": "kg"
    },
    {
        "code": "JE",
        "country_flag": "jersey.png",
        "country_phone_code": 44,
        "currency": "USD",
        "elevated_risk": 0,
        "id": "5e1d719851d75f1c3f69ffb2",
        "is_bfm": false,
        "is_host": 0,
        "lang": "JE",
        "name": "Jersey",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "",
        "weight_unit": "kg"
    },
    {
        "code": "JO",
        "country_flag": "jordan.png",
        "country_phone_code": "962",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e1536c2d3cf0080185c",
        "is_bfm": false,
        "is_host": 0,
        "lang": "JO",
        "name": "Jordan",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+2",
        "weight_unit": "kg"
    },
    {
        "code": "KZ",
        "country_flag": "kazakhstan.png",
        "country_phone_code": "7",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e1e36c2d3cf00801872",
        "is_bfm": false,
        "is_host": 0,
        "lang": "KZ",
        "name": "Kazakhstan",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+4",
        "weight_unit": "kg"
    },
    {
        "code": "KE",
        "country_flag": "kenya.png",
        "country_phone_code": "254",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e1236c2d3cf00801855",
        "is_bfm": false,
        "is_host": 0,
        "lang": "KE",
        "name": "Kenya",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+3",
        "weight_unit": "kg"
    },
    {
        "code": "KI",
        "country_flag": "kiribati.png",
        "country_phone_code": "686",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2e36c2d3cf008018a8",
        "is_bfm": false,
        "is_host": 0,
        "lang": "KI",
        "name": "Kiribati",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+12",
        "weight_unit": "kg"
    },
    {
        "code": "KS",
        "country_flag": "kosovo.png",
        "country_phone_code": 383,
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6ff536c2d3cf00801908",
        "is_bfm": false,
        "is_host": 0,
        "lang": "ALB",
        "name": "Kosovo",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "KW",
        "country_flag": "kuwait.png",
        "country_phone_code": "965",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e1736c2d3cf00801860",
        "is_bfm": false,
        "is_host": 0,
        "lang": "KW",
        "name": "Kuwait",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+3",
        "weight_unit": "kg"
    },
    {
        "code": "KG",
        "country_flag": "kyrgyzstan.png",
        "country_phone_code": "996",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2936c2d3cf00801899",
        "is_bfm": false,
        "is_host": 0,
        "lang": "KG",
        "name": "Kyrgyzstan",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+5",
        "weight_unit": "kg"
    },
    {
        "code": "LA",
        "country_flag": "laos.png",
        "country_phone_code": "856",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2a36c2d3cf0080189c",
        "is_bfm": false,
        "is_host": 0,
        "lang": "LA",
        "name": "Laos",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+7",
        "weight_unit": "kg"
    },
    {
        "code": "LV",
        "country_flag": "latvia.png",
        "country_phone_code": "371",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e1d36c2d3cf0080186e",
        "is_bfm": false,
        "is_host": 0,
        "lang": "LV",
        "name": "Latvia",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+2",
        "weight_unit": "kg"
    },
    {
        "code": "LB",
        "country_flag": "lebanon.png",
        "country_phone_code": "961",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e1636c2d3cf0080185e",
        "is_bfm": false,
        "is_host": 0,
        "lang": "LB",
        "name": "Lebanon",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+2",
        "weight_unit": "kg"
    },
    {
        "code": "LS",
        "country_flag": "lesotho.png",
        "country_phone_code": "266",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2336c2d3cf00801883",
        "is_bfm": false,
        "is_host": 0,
        "lang": "LS",
        "name": "Lesotho",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+3",
        "weight_unit": "kg"
    },
    {
        "code": "LR",
        "country_flag": "liberia.png",
        "country_phone_code": "231",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e3636c2d3cf008018b3",
        "is_bfm": false,
        "is_host": 0,
        "lang": "LR",
        "name": "Liberia",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+0",
        "weight_unit": "kg"
    },
    {
        "code": "LY",
        "country_flag": "libya.png",
        "country_phone_code": "218",
        "currency": "USD",
        "elevated_risk": 1,
        "id": "581c6e0c36c2d3cf0080184a",
        "is_bfm": false,
        "is_host": 0,
        "lang": "LY",
        "name": "Libya",
        "non_standart_pickup": 1,
        "restricted_destination": 1,
        "status": 1,
        "timezone": "GMT+2",
        "weight_unit": "kg"
    },
    {
        "code": "LI",
        "country_flag": "liechtenstein.png",
        "country_phone_code": "423",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e4136c2d3cf008018d3",
        "is_bfm": false,
        "is_host": 0,
        "lang": "LI",
        "name": "Liechtenstein",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "LT",
        "country_flag": "lithuania.png",
        "country_phone_code": "370",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e1d36c2d3cf00801870",
        "is_bfm": false,
        "is_host": 0,
        "lang": "LT",
        "name": "Lithuania",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+2",
        "weight_unit": "kg"
    },
    {
        "code": "LU",
        "country_flag": "luxembourg.png",
        "country_phone_code": "352",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e4036c2d3cf008018d0",
        "is_bfm": false,
        "is_host": 0,
        "lang": "LU",
        "name": "Luxembourg",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "MO",
        "country_flag": "macau.png",
        "country_phone_code": 853,
        "currency": "USD",
        "elevated_risk": 0,
        "id": "5e1d719851d75f1c3f69ffb4",
        "is_bfm": false,
        "is_host": 0,
        "lang": "MO",
        "name": "Macau",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "",
        "weight_unit": "kg"
    },
    {
        "code": "MG",
        "country_flag": "madagascar.png",
        "country_phone_code": "261",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "586f36903901ad0e8d29f053",
        "is_bfm": false,
        "is_host": 0,
        "lang": "MG",
        "name": "Madagascar",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+3",
        "weight_unit": "kg"
    },
    {
        "code": "MW",
        "country_flag": "malawi.png",
        "country_phone_code": "265",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2336c2d3cf00801882",
        "is_bfm": false,
        "is_host": 0,
        "lang": "MW",
        "name": "Malawi",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+2",
        "weight_unit": "kg"
    },
    {
        "code": "MY",
        "country_flag": "malaysia.png",
        "country_phone_code": "60",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2736c2d3cf00801890",
        "is_bfm": true,
        "is_host": 1,
        "lang": "MY",
        "name": "Malaysia",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+8",
        "weight_unit": "kg"
    },
    {
        "code": "MV",
        "country_flag": "maldives.png",
        "country_phone_code": "960",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2836c2d3cf00801895",
        "is_bfm": false,
        "is_host": 0,
        "lang": "MV",
        "name": "Maldives",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+5",
        "weight_unit": "kg"
    },
    {
        "code": "ML",
        "country_flag": "mali.png",
        "country_phone_code": "223",
        "currency": "USD",
        "elevated_risk": 1,
        "id": "581c6e3b36c2d3cf008018c3",
        "is_bfm": false,
        "is_host": 0,
        "lang": "ML",
        "name": "Mali",
        "non_standart_pickup": 1,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+0",
        "weight_unit": "kg"
    },
    {
        "code": "MT",
        "country_flag": "malta.png",
        "country_phone_code": "356",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e3c36c2d3cf008018c7",
        "is_bfm": false,
        "is_host": 0,
        "lang": "MT",
        "name": "Malta",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "MH",
        "country_flag": "marshall-islands.png",
        "country_phone_code": "692",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e6936c2d3cf00801905",
        "is_bfm": false,
        "is_host": 0,
        "lang": "MH",
        "name": "Marshall Islands",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+12",
        "weight_unit": "kg"
    },
    {
        "code": "MQ",
        "country_flag": "martinique.png",
        "country_phone_code": 596,
        "currency": "USD",
        "elevated_risk": 0,
        "id": "5e1d719851d75f1c3f69ffb5",
        "is_bfm": false,
        "is_host": 0,
        "lang": "MQ",
        "name": "Martinique",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "",
        "weight_unit": "kg"
    },
    {
        "code": "MR",
        "country_flag": "mauritania.png",
        "country_phone_code": "222",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e3936c2d3cf008018bb",
        "is_bfm": false,
        "is_host": 0,
        "lang": "MR",
        "name": "Mauritania",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+0",
        "weight_unit": "kg"
    },
    {
        "code": "MU",
        "country_flag": "mauritius.png",
        "country_phone_code": "230",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2436c2d3cf00801885",
        "is_bfm": false,
        "is_host": 0,
        "lang": "MU",
        "name": "Mauritius",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+4",
        "weight_unit": "kg"
    },
    {
        "code": "YT",
        "country_flag": "mayotte.png",
        "country_phone_code": 262,
        "currency": "USD",
        "elevated_risk": 0,
        "id": "5e1d719851d75f1c3f69ffb6",
        "is_bfm": false,
        "is_host": 0,
        "lang": "YT",
        "name": "Mayotte",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "",
        "weight_unit": "kg"
    },
    {
        "code": "MX",
        "country_flag": "mexico.png",
        "country_phone_code": "52",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e5036c2d3cf008018e5",
        "is_bfm": false,
        "is_host": 0,
        "lang": "MX",
        "name": "Mexico",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-6",
        "weight_unit": "kg"
    },
    {
        "code": "MD",
        "country_flag": "moldova.png",
        "country_phone_code": "373",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e1f36c2d3cf00801874",
        "is_bfm": false,
        "is_host": 0,
        "lang": "MD",
        "name": "Moldova",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+2",
        "weight_unit": "kg"
    },
    {
        "code": "MC",
        "country_flag": "monaco.png",
        "country_phone_code": "377",
        "currency": "EUR",
        "elevated_risk": 0,
        "id": "5bd04ed1ed59fc68788e6ca2",
        "is_bfm": false,
        "is_host": 0,
        "lang": "fr-FR",
        "name": "Monaco",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "MN",
        "country_flag": "mongolia.png",
        "country_phone_code": "976",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2936c2d3cf00801898",
        "is_bfm": false,
        "is_host": 0,
        "lang": "MN",
        "name": "Mongolia",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+8",
        "weight_unit": "kg"
    },
    {
        "code": "ME",
        "country_flag": "montenegro.png",
        "country_phone_code": 382,
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e4736c2d3cf008018d9",
        "is_bfm": false,
        "is_host": 0,
        "lang": "ME",
        "name": "Montenegro",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "MS",
        "country_flag": "montserrat.png",
        "country_phone_code": 1,
        "currency": "USD",
        "elevated_risk": 0,
        "id": "5e1d719851d75f1c3f69ffb7",
        "is_bfm": false,
        "is_host": 0,
        "lang": "MS",
        "name": "Montserrat",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "",
        "weight_unit": "kg"
    },
    {
        "code": "MA",
        "country_flag": "morocco.png",
        "country_phone_code": "212",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e3c36c2d3cf008018c6",
        "is_bfm": false,
        "is_host": 0,
        "lang": "MA",
        "name": "Morocco",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "MZ",
        "country_flag": "mozambique.png",
        "country_phone_code": "258",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2536c2d3cf00801888",
        "is_bfm": false,
        "is_host": 0,
        "lang": "MZ",
        "name": "Mozambique",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+2",
        "weight_unit": "kg"
    },
    {
        "code": "MM",
        "country_flag": "myanmar-[burma].png",
        "country_phone_code": "95",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2936c2d3cf00801897",
        "is_bfm": false,
        "is_host": 0,
        "lang": "MM",
        "name": "Myanmar [Burma]",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+6:30",
        "weight_unit": "kg"
    },
    {
        "code": "NA",
        "country_flag": "namibia.png",
        "country_phone_code": "264",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2236c2d3cf0080187f",
        "is_bfm": false,
        "is_host": 0,
        "lang": "NA",
        "name": "Namibia",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "NR",
        "country_flag": "nauru.png",
        "country_phone_code": "674",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2f36c2d3cf008018aa",
        "is_bfm": false,
        "is_host": 0,
        "lang": "NR",
        "name": "Nauru",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+12",
        "weight_unit": "kg"
    },
    {
        "code": "NP",
        "country_flag": "nepal.png",
        "country_phone_code": "977",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2936c2d3cf00801896",
        "is_bfm": false,
        "is_host": 0,
        "lang": "NP",
        "name": "Nepal",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+5:45",
        "weight_unit": "kg"
    },
    {
        "code": "NL",
        "country_flag": "netherlands.png",
        "country_phone_code": "31",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e3f36c2d3cf008018ce",
        "is_bfm": false,
        "is_host": 1,
        "lang": "NL",
        "name": "Netherlands",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "AN",
        "country_flag": "netherlands-antilles.png",
        "country_phone_code": 599,
        "currency": "USD",
        "elevated_risk": 0,
        "id": "5e20232d51d75f4ebb13d115",
        "is_bfm": false,
        "is_host": 0,
        "lang": "AN",
        "name": "Netherlands Antilles",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "",
        "weight_unit": "kg"
    },
    {
        "code": "XN",
        "country_flag": "nevis.png",
        "country_phone_code": 1869,
        "currency": "USD",
        "elevated_risk": 0,
        "id": "5e1d719851d75f1c3f69ffb8",
        "is_bfm": false,
        "is_host": 0,
        "lang": "XN",
        "name": "Nevis",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "",
        "weight_unit": "kg"
    },
    {
        "code": "NC",
        "country_flag": "new-caledonia.png",
        "country_phone_code": "687",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e3036c2d3cf008018ac",
        "is_bfm": false,
        "is_host": 0,
        "lang": "NC",
        "name": "New Caledonia",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "",
        "weight_unit": "kg"
    },
    {
        "code": "NZ",
        "country_flag": "new-zealand.png",
        "country_phone_code": "64",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e3136c2d3cf008018ad",
        "is_bfm": false,
        "is_host": 0,
        "lang": "NZ",
        "name": "New Zealand",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+12",
        "weight_unit": "kg"
    },
    {
        "code": "NI",
        "country_flag": "nicaragua.png",
        "country_phone_code": "505",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e5f36c2d3cf008018f7",
        "is_bfm": false,
        "is_host": 0,
        "lang": "NI",
        "name": "Nicaragua",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-6",
        "weight_unit": "kg"
    },
    {
        "code": "NE",
        "country_flag": "niger.png",
        "country_phone_code": "227",
        "currency": "USD",
        "elevated_risk": 1,
        "id": "581c6e3b36c2d3cf008018c2",
        "is_bfm": false,
        "is_host": 0,
        "lang": "NE",
        "name": "Niger",
        "non_standart_pickup": 1,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "NG",
        "country_flag": "nigeria.png",
        "country_phone_code": "234",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e3736c2d3cf008018b7",
        "is_bfm": false,
        "is_host": 0,
        "lang": "NG",
        "name": "Nigeria",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "NU",
        "country_flag": "niue.png",
        "country_phone_code": 683,
        "currency": "USD",
        "elevated_risk": 0,
        "id": "5e1d719851d75f1c3f69ffb9",
        "is_bfm": false,
        "is_host": 0,
        "lang": "NU",
        "name": "Niue",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "",
        "weight_unit": "kg"
    },
    {
        "code": "MK",
        "country_flag": "north-macedonia.png",
        "country_phone_code": "389",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2236c2d3cf0080187e",
        "is_bfm": false,
        "is_host": 0,
        "lang": "MK",
        "name": "North Macedonia",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "MP",
        "country_flag": "northern-mariana-islands.png",
        "country_phone_code": "1-670",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e6a36c2d3cf00801907",
        "is_bfm": false,
        "is_host": 0,
        "lang": "MP",
        "name": "Northern Mariana Islands",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "",
        "weight_unit": "kg"
    },
    {
        "code": "NO",
        "country_flag": "norway.png",
        "country_phone_code": "47",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2136c2d3cf0080187c",
        "is_bfm": false,
        "is_host": 0,
        "lang": "NO",
        "name": "Norway",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "OM",
        "country_flag": "oman.png",
        "country_phone_code": "968",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e1736c2d3cf00801861",
        "is_bfm": false,
        "is_host": 0,
        "lang": "OM",
        "name": "Oman",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+4",
        "weight_unit": "kg"
    },
    {
        "code": "PK",
        "country_flag": "pakistan.png",
        "country_phone_code": "92",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2636c2d3cf0080188c",
        "is_bfm": false,
        "is_host": 0,
        "lang": "PK",
        "name": "Pakistan",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+5",
        "weight_unit": "kg"
    },
    {
        "code": "PW",
        "country_flag": "palau.png",
        "country_phone_code": 680,
        "currency": "USD",
        "elevated_risk": 0,
        "id": "5e1d719851d75f1c3f69ffba",
        "is_bfm": false,
        "is_host": 0,
        "lang": "PW",
        "name": "Palau",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+9",
        "weight_unit": "kg"
    },
    {
        "code": "PS",
        "country_flag": "palestine.png",
        "country_phone_code": 970,
        "currency": "USD",
        "elevated_risk": 0,
        "id": "5e1d9e7d51d75f203aa34db0",
        "is_bfm": false,
        "is_host": 0,
        "lang": "PS",
        "name": "Palestine",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+2",
        "weight_unit": "kg"
    },
    {
        "code": "PA",
        "country_flag": "panama.png",
        "country_phone_code": "507",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e6336c2d3cf008018fc",
        "is_bfm": false,
        "is_host": 0,
        "lang": "PA",
        "name": "Panama",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-5",
        "weight_unit": "kg"
    },
    {
        "code": "PG",
        "country_flag": "papua-new-guinea.png",
        "country_phone_code": "675",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2e36c2d3cf008018a6",
        "is_bfm": false,
        "is_host": 0,
        "lang": "PG",
        "name": "Papua New Guinea",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+10",
        "weight_unit": "kg"
    },
    {
        "code": "PY",
        "country_flag": "paraguay.png",
        "country_phone_code": "595",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e4f36c2d3cf008018e2",
        "is_bfm": false,
        "is_host": 0,
        "lang": "PY",
        "name": "Paraguay",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-4",
        "weight_unit": "kg"
    },
    {
        "code": "PE",
        "country_flag": "peru.png",
        "country_phone_code": "51",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e6336c2d3cf008018fb",
        "is_bfm": false,
        "is_host": 0,
        "lang": "PE",
        "name": "Peru",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-5",
        "weight_unit": "kg"
    },
    {
        "code": "PH",
        "country_flag": "philippines.png",
        "country_phone_code": "63",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2b36c2d3cf0080189e",
        "is_bfm": false,
        "is_host": 0,
        "lang": "PH",
        "name": "Philippines",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+8",
        "weight_unit": "kg"
    },
    {
        "code": "PL",
        "country_flag": "poland.png",
        "country_phone_code": "48",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2136c2d3cf0080187b",
        "is_bfm": false,
        "is_host": 1,
        "lang": "PL",
        "name": "Poland",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "PT",
        "country_flag": "portugal.png",
        "country_phone_code": "351",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e3536c2d3cf008018b2",
        "is_bfm": false,
        "is_host": 0,
        "lang": "PT",
        "name": "Portugal",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+0",
        "weight_unit": "kg"
    },
    {
        "code": "PR",
        "country_flag": "puerto-rico.png",
        "country_phone_code": "1",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "584f98ee3901ad0e8d29ed24",
        "is_bfm": false,
        "is_host": 0,
        "lang": "PR",
        "name": "Puerto Rico",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "",
        "weight_unit": "kg"
    },
    {
        "code": "QA",
        "country_flag": "qatar.png",
        "country_phone_code": "974 ",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e1836c2d3cf00801862",
        "is_bfm": false,
        "is_host": 0,
        "lang": "QA",
        "name": "Qatar",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+3",
        "weight_unit": "kg"
    },
    {
        "code": "CG",
        "country_flag": "republic-of-the-congo.png",
        "country_phone_code": "242",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e3536c2d3cf008018b1",
        "is_bfm": false,
        "is_host": 0,
        "lang": "CG",
        "name": "Republic of the Congo",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "RE",
        "country_flag": "reunion.png",
        "country_phone_code": 262,
        "currency": "USD",
        "elevated_risk": 0,
        "id": "5e1d719851d75f1c3f69ffbb",
        "is_bfm": false,
        "is_host": 0,
        "lang": "RE",
        "name": "Reunion",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "",
        "weight_unit": "kg"
    },
    {
        "code": "RO",
        "country_flag": "romania.png",
        "country_phone_code": "40",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2036c2d3cf00801878",
        "is_bfm": false,
        "is_host": 0,
        "lang": "RO",
        "name": "Romania",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+2",
        "weight_unit": "kg"
    },
    {
        "code": "RU",
        "country_flag": "russia.png",
        "country_phone_code": "7",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e1c36c2d3cf0080186c",
        "is_bfm": false,
        "is_host": 0,
        "lang": "RU",
        "name": "Russia",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+2",
        "weight_unit": "kg"
    },
    {
        "code": "RW",
        "country_flag": "rwanda.png",
        "country_phone_code": "250",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e1236c2d3cf00801856",
        "is_bfm": false,
        "is_host": 0,
        "lang": "RW",
        "name": "Rwanda",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+2",
        "weight_unit": "kg"
    },
    {
        "code": "XE",
        "country_flag": "st-eustaius.png",
        "country_phone_code": 0,
        "currency": "USD",
        "elevated_risk": 0,
        "id": "5e1d719851d75f1c3f69ffbe",
        "is_bfm": false,
        "is_host": 0,
        "lang": "XE",
        "name": "ST Eustaius",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "",
        "weight_unit": "kg"
    },
    {
        "code": "SH",
        "country_flag": "st-helena.png",
        "country_phone_code": 290,
        "currency": "USD",
        "elevated_risk": 0,
        "id": "5e1d719851d75f1c3f69ffbf",
        "is_bfm": false,
        "is_host": 0,
        "lang": "SH",
        "name": "ST Helena",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "",
        "weight_unit": "kg"
    },
    {
        "code": "XM",
        "country_flag": "st-maarten.png",
        "country_phone_code": 599,
        "currency": "USD",
        "elevated_risk": 0,
        "id": "5e1d719851d75f1c3f69ffc0",
        "is_bfm": false,
        "is_host": 0,
        "lang": "XM",
        "name": "ST Maarten",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "",
        "weight_unit": "kg"
    },
    {
        "code": "KN",
        "country_flag": "saint-kitts-and-nevis.png",
        "country_phone_code": "1-869",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e5636c2d3cf008018ed",
        "is_bfm": false,
        "is_host": 0,
        "lang": "KN",
        "name": "Saint Kitts and Nevis",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-4",
        "weight_unit": "kg"
    },
    {
        "code": "LC",
        "country_flag": "saint-lucia.png",
        "country_phone_code": "1-758",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e5836c2d3cf008018f0",
        "is_bfm": false,
        "is_host": 0,
        "lang": "LC",
        "name": "Saint Lucia",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-4",
        "weight_unit": "kg"
    },
    {
        "code": "PM",
        "country_flag": "saint-pierre-&-miquelon.png",
        "country_phone_code": 508,
        "currency": "USD",
        "elevated_risk": "",
        "id": "5e43ee0651d75f1dcd0d58a6",
        "is_bfm": false,
        "is_host": 0,
        "lang": "PM",
        "name": "Saint Pierre & Miquelon",
        "non_standart_pickup": "",
        "restricted_destination": "",
        "status": 1,
        "timezone": "",
        "weight_unit": "kg"
    },
    {
        "code": "VC",
        "country_flag": "saint-vincent-and-the-grenadines.png",
        "country_phone_code": "1-784",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e5936c2d3cf008018f1",
        "is_bfm": false,
        "is_host": 0,
        "lang": "VC",
        "name": "Saint Vincent and the Grenadines",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-4",
        "weight_unit": "kg"
    },
    {
        "code": "WS",
        "country_flag": "samoa.png",
        "country_phone_code": "685",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e6836c2d3cf00801902",
        "is_bfm": false,
        "is_host": 0,
        "lang": "WS",
        "name": "Samoa",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-11",
        "weight_unit": "kg"
    },
    {
        "code": "SM",
        "country_flag": "san-marino.png",
        "country_phone_code": "378",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e4236c2d3cf008018d5",
        "is_bfm": false,
        "is_host": 0,
        "lang": "SM",
        "name": "San Marino",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "ST",
        "country_flag": "sao-tome-and-principe.png",
        "country_phone_code": "239",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e3a36c2d3cf008018bf",
        "is_bfm": false,
        "is_host": 0,
        "lang": "ST",
        "name": "Sao Tome and Principe",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "",
        "weight_unit": "kg"
    },
    {
        "code": "SA",
        "country_flag": "saudi-arabia.png",
        "country_phone_code": "966",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e0d36c2d3cf0080184c",
        "is_bfm": false,
        "is_host": 1,
        "lang": "SA",
        "name": "Saudi Arabia",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+3",
        "weight_unit": "kg"
    },
    {
        "code": "SN",
        "country_flag": "senegal.png",
        "country_phone_code": "221",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e3436c2d3cf008018b0",
        "is_bfm": false,
        "is_host": 0,
        "lang": "SN",
        "name": "Senegal",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+0",
        "weight_unit": "kg"
    },
    {
        "code": "RS",
        "country_flag": "serbia.png",
        "country_phone_code": 381,
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2236c2d3cf0080187d",
        "is_bfm": false,
        "is_host": 0,
        "lang": "RS",
        "name": "Serbia",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "SC",
        "country_flag": "seychelles.png",
        "country_phone_code": "248",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e1436c2d3cf0080185a",
        "is_bfm": false,
        "is_host": 0,
        "lang": "SC",
        "name": "Seychelles",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+4",
        "weight_unit": "kg"
    },
    {
        "code": "SL",
        "country_flag": "sierra-leone.png",
        "country_phone_code": "232",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e3a36c2d3cf008018be",
        "is_bfm": false,
        "is_host": 0,
        "lang": "SL",
        "name": "Sierra Leone",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+0",
        "weight_unit": "kg"
    },
    {
        "code": "SG",
        "country_flag": "singapore.png",
        "country_phone_code": "65",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2d36c2d3cf008018a4",
        "is_bfm": true,
        "is_host": 1,
        "lang": "SG",
        "name": "Singapore",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+8",
        "weight_unit": "kg"
    },
    {
        "code": "SX",
        "country_flag": "sint-maarten-(dutch-part).png",
        "country_phone_code": 0,
        "currency": "USD",
        "elevated_risk": "",
        "id": "5e43ee0651d75f1dcd0d58a8",
        "is_bfm": false,
        "is_host": 0,
        "lang": "SX",
        "name": "Sint Maarten (Dutch part)",
        "non_standart_pickup": "",
        "restricted_destination": "",
        "status": 1,
        "timezone": "",
        "weight_unit": "kg"
    },
    {
        "code": "SK",
        "country_flag": "slovakia.png",
        "country_phone_code": "421",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2136c2d3cf0080187a",
        "is_bfm": false,
        "is_host": 0,
        "lang": "SK",
        "name": "Slovakia",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "SI",
        "country_flag": "slovenia.png",
        "country_phone_code": "386",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e4336c2d3cf008018d6",
        "is_bfm": false,
        "is_host": 0,
        "lang": "SI",
        "name": "Slovenia",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "SB",
        "country_flag": "solomon-islands.png",
        "country_phone_code": "677",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2e36c2d3cf008018a7",
        "is_bfm": false,
        "is_host": 0,
        "lang": "SB",
        "name": "Solomon Islands",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+11",
        "weight_unit": "kg"
    },
    {
        "code": "XS",
        "country_flag": "somaliland.png",
        "country_phone_code": 252,
        "currency": "USD",
        "elevated_risk": 0,
        "id": "5e1d719851d75f1c3f69ffbc",
        "is_bfm": false,
        "is_host": 0,
        "lang": "XS",
        "name": "Somaliland",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "",
        "weight_unit": "kg"
    },
    {
        "code": "ZA",
        "country_flag": "south-africa.png",
        "country_phone_code": "27",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2436c2d3cf00801887",
        "is_bfm": false,
        "is_host": 0,
        "lang": "ZA",
        "name": "South Africa",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+2",
        "weight_unit": "kg"
    },
    {
        "code": "KR",
        "country_flag": "south-korea.png",
        "country_phone_code": "82",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2c36c2d3cf008018a2",
        "is_bfm": false,
        "is_host": 0,
        "lang": "KR",
        "name": "South Korea",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+9",
        "weight_unit": "kg"
    },
    {
        "code": "ES",
        "country_flag": "spain.png",
        "country_phone_code": "34",
        "currency": "EUR",
        "elevated_risk": 0,
        "id": "581afdc536c2d3cf00801557",
        "is_bfm": false,
        "is_host": 1,
        "lang": "es-ES",
        "name": "Spain",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "LK",
        "country_flag": "sri-lanka.png",
        "country_phone_code": "94",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2736c2d3cf00801891",
        "is_bfm": false,
        "is_host": 0,
        "lang": "LK",
        "name": "Sri Lanka",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+5:30",
        "weight_unit": "kg"
    },
    {
        "code": "BL",
        "country_flag": "st.-barthelemy.png",
        "country_phone_code": 590,
        "currency": "USD",
        "elevated_risk": 0,
        "id": "5e20232d51d75f4ebb13d119",
        "is_bfm": false,
        "is_host": 0,
        "lang": "BL",
        "name": "St. Barthelemy",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "",
        "weight_unit": "kg"
    },
    {
        "code": "SR",
        "country_flag": "suriname.png",
        "country_phone_code": "597",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e4a36c2d3cf008018dd",
        "is_bfm": false,
        "is_host": 0,
        "lang": "SR",
        "name": "Suriname",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-3",
        "weight_unit": "kg"
    },
    {
        "code": "SZ",
        "country_flag": "swaziland.png",
        "country_phone_code": "268",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2436c2d3cf00801886",
        "is_bfm": false,
        "is_host": 0,
        "lang": "SZ",
        "name": "Swaziland",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+2",
        "weight_unit": "kg"
    },
    {
        "code": "SE",
        "country_flag": "sweden.png",
        "country_phone_code": "46",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e1e36c2d3cf00801871",
        "is_bfm": true,
        "is_host": 1,
        "lang": "SE",
        "name": "Sweden",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "CH",
        "country_flag": "switzerland.png",
        "country_phone_code": "41",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e3f36c2d3cf008018cc",
        "is_bfm": true,
        "is_host": 1,
        "lang": "CH",
        "name": "Switzerland",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "SY",
        "country_flag": "syria.png",
        "country_phone_code": "963",
        "currency": "USD",
        "elevated_risk": 1,
        "id": "581c6e1136c2d3cf00801852",
        "is_bfm": false,
        "is_host": 0,
        "lang": "SY",
        "name": "Syria",
        "non_standart_pickup": 1,
        "restricted_destination": 1,
        "status": 1,
        "timezone": "GMT+2",
        "weight_unit": "kg"
    },
    {
        "code": "TW",
        "country_flag": "taiwan.png",
        "country_phone_code": "886",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2a36c2d3cf0080189d",
        "is_bfm": false,
        "is_host": 0,
        "lang": "TW",
        "name": "Taiwan",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+8",
        "weight_unit": "kg"
    },
    {
        "code": "TJ",
        "country_flag": "tajikistan.png",
        "country_phone_code": "992",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2736c2d3cf0080188f",
        "is_bfm": false,
        "is_host": 0,
        "lang": "TJ",
        "name": "Tajikistan",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+5",
        "weight_unit": "kg"
    },
    {
        "code": "TZ",
        "country_flag": "tanzania.png",
        "country_phone_code": "255",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e0f36c2d3cf00801850",
        "is_bfm": false,
        "is_host": 0,
        "lang": "TZ",
        "name": "Tanzania",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+3",
        "weight_unit": "kg"
    },
    {
        "code": "TH",
        "country_flag": "thailand.png",
        "country_phone_code": "66",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2536c2d3cf0080188a",
        "is_bfm": false,
        "is_host": 0,
        "lang": "TH",
        "name": "Thailand",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+7",
        "weight_unit": "kg"
    },
    {
        "code": "TG",
        "country_flag": "togo.png",
        "country_phone_code": 228,
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e3836c2d3cf008018b9",
        "is_bfm": false,
        "is_host": 0,
        "lang": "TG",
        "name": "Togo",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+0",
        "weight_unit": "kg"
    },
    {
        "code": "TK",
        "country_flag": "tokelau.png",
        "country_phone_code": "690",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e6a36c2d3cf00801906",
        "is_bfm": false,
        "is_host": 0,
        "lang": "TK",
        "name": "Tokelau",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "",
        "weight_unit": "kg"
    },
    {
        "code": "TO",
        "country_flag": "tonga.png",
        "country_phone_code": "676",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e6636c2d3cf00801900",
        "is_bfm": false,
        "is_host": 0,
        "lang": "TO",
        "name": "Tonga",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "",
        "weight_unit": "kg"
    },
    {
        "code": "TT",
        "country_flag": "trinidad-and-tobago.png",
        "country_phone_code": "1-868",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e5636c2d3cf008018ec",
        "is_bfm": false,
        "is_host": 0,
        "lang": "TT",
        "name": "Trinidad and Tobago",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-4",
        "weight_unit": "kg"
    },
    {
        "code": "TN",
        "country_flag": "tunisia.png",
        "country_phone_code": "216",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e3b36c2d3cf008018c4",
        "is_bfm": false,
        "is_host": 0,
        "lang": "TN",
        "name": "Tunisia",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "TR",
        "country_flag": "turkey.png",
        "country_phone_code": "90",
        "currency": "TRY",
        "elevated_risk": 0,
        "id": "581afddd36c2d3cf00801558",
        "is_bfm": true,
        "is_host": 1,
        "lang": "tr-TR",
        "name": "Turkey",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+2",
        "weight_unit": "kg"
    },
    {
        "code": "TM",
        "country_flag": "turkmenistan.png",
        "country_phone_code": "993",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e0f36c2d3cf00801851",
        "is_bfm": false,
        "is_host": 0,
        "lang": "TM",
        "name": "Turkmenistan",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+5",
        "weight_unit": "kg"
    },
    {
        "code": "TC",
        "country_flag": "turks-and-caicos-islands.png",
        "country_phone_code": "1-649",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "5820621e36c2d3cf00802556",
        "is_bfm": false,
        "is_host": 0,
        "lang": "TC",
        "name": "Turks and Caicos Islands",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "",
        "weight_unit": "kg"
    },
    {
        "code": "TV",
        "country_flag": "tuvalu.png",
        "country_phone_code": "688",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2f36c2d3cf008018a9",
        "is_bfm": false,
        "is_host": 0,
        "lang": "TV",
        "name": "Tuvalu",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+12",
        "weight_unit": "kg"
    },
    {
        "code": "VI",
        "country_flag": "u.s.-virgin-islands.png",
        "country_phone_code": "1-284",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e6936c2d3cf00801903",
        "is_bfm": false,
        "is_host": 0,
        "lang": "VI",
        "name": "U.S. Virgin Islands",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "",
        "weight_unit": "kg"
    },
    {
        "code": "UG",
        "country_flag": "uganda.png",
        "country_phone_code": "256",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e1336c2d3cf00801858",
        "is_bfm": false,
        "is_host": 0,
        "lang": "UG",
        "name": "Uganda",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+3",
        "weight_unit": "kg"
    },
    {
        "code": "UA",
        "country_flag": "ukraine.png",
        "country_phone_code": "380",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2036c2d3cf00801876",
        "is_bfm": false,
        "is_host": 0,
        "lang": "UA",
        "name": "Ukraine",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+2",
        "weight_unit": "kg"
    },
    {
        "code": "AE",
        "country_flag": "united-arab-emirates.png",
        "country_phone_code": "971",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e1836c2d3cf00801864",
        "is_bfm": false,
        "is_host": 0,
        "lang": "AE",
        "name": "United Arab Emirates",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+4",
        "weight_unit": "kg"
    },
    {
        "code": "UK",
        "country_flag": "united-kingdom.png",
        "country_phone_code": "44",
        "currency": "GBP",
        "elevated_risk": 0,
        "id": "581afe1b36c2d3cf00801559",
        "is_bfm": true,
        "is_host": 1,
        "lang": "uk-UK",
        "name": "United Kingdom",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+0",
        "weight_unit": "kg"
    },
    {
        "code": "US",
        "country_flag": "united-states-of-america.png",
        "country_phone_code": "1",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "58344fab7f42fc363aa4c26b",
        "is_bfm": true,
        "is_host": 1,
        "lang": "en-EN",
        "name": "United States of America",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-6",
        "weight_unit": "lbs"
    },
    {
        "code": "UY",
        "country_flag": "uruguay.png",
        "country_phone_code": "598",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e4f36c2d3cf008018e3",
        "is_bfm": false,
        "is_host": 0,
        "lang": "UY",
        "name": "Uruguay",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-3",
        "weight_unit": "kg"
    },
    {
        "code": "UZ",
        "country_flag": "uzbekistan.png",
        "country_phone_code": "998",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2536c2d3cf00801889",
        "is_bfm": false,
        "is_host": 0,
        "lang": "UZ",
        "name": "Uzbekistan",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+5",
        "weight_unit": "kg"
    },
    {
        "code": "VU",
        "country_flag": "vanuatu.png",
        "country_phone_code": "678",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e3036c2d3cf008018ab",
        "is_bfm": false,
        "is_host": 0,
        "lang": "VU",
        "name": "Vanuatu",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+11",
        "weight_unit": "kg"
    },
    {
        "code": "VA",
        "country_flag": "vatican-city.png",
        "country_phone_code": 379,
        "currency": "USD",
        "elevated_risk": 0,
        "id": "5e1d719851d75f1c3f69ffc1",
        "is_bfm": false,
        "is_host": 0,
        "lang": "VA",
        "name": "Vatican City",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+1",
        "weight_unit": "kg"
    },
    {
        "code": "VE",
        "country_flag": "venezuela.png",
        "country_phone_code": "58",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e5036c2d3cf008018e4",
        "is_bfm": false,
        "is_host": 0,
        "lang": "VE",
        "name": "Venezuela",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT-4",
        "weight_unit": "kg"
    },
    {
        "code": "VN",
        "country_flag": "vietnam.png",
        "country_phone_code": "84",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e2a36c2d3cf0080189a",
        "is_bfm": false,
        "is_host": 0,
        "lang": "VN",
        "name": "Vietnam",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+7",
        "weight_unit": "kg"
    },
    {
        "code": "WF",
        "country_flag": "wallis-&-futuna.png",
        "country_phone_code": 681,
        "currency": "USD",
        "elevated_risk": 0,
        "id": "5e1d9e7d51d75f203aa34db6",
        "is_bfm": false,
        "is_host": 0,
        "lang": "WF",
        "name": "Wallis & Futuna",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "",
        "weight_unit": "kg"
    },
    {
        "code": "YE",
        "country_flag": "yemen.png",
        "country_phone_code": "967",
        "currency": "USD",
        "elevated_risk": 1,
        "id": "581c6e0c36c2d3cf00801849",
        "is_bfm": false,
        "is_host": 0,
        "lang": "YE",
        "name": "Yemen",
        "non_standart_pickup": 1,
        "restricted_destination": 1,
        "status": 1,
        "timezone": "GMT+3",
        "weight_unit": "kg"
    },
    {
        "code": "ZM",
        "country_flag": "zambia.png",
        "country_phone_code": "260",
        "currency": "USD",
        "elevated_risk": 0,
        "id": "581c6e1136c2d3cf00801854",
        "is_bfm": false,
        "is_host": 0,
        "lang": "ZM",
        "name": "Zambia",
        "non_standart_pickup": 0,
        "restricted_destination": 0,
        "status": 1,
        "timezone": "GMT+2",
        "weight_unit": "kg"
    }
]